import { fetchWithErrorThrowing, standardDateFormat } from 'ck-utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PostPushNotification } from './types';
import dayjs from 'dayjs';
import { toast } from 'react-hot-toast';

// Mutation hook
export const useNotificationsCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: PostPushNotification) =>
      toast.promise(
        createNotification(data),
        {
          loading: 'Laddar...',
          success: data.isDraft
            ? 'Utkast sparat'
            : data.scheduleTime
            ? `Pushnotis schemalagd \ntill ${dayjs(data.scheduleTime).format(
                standardDateFormat
              )}`
            : 'Pushnotis skickad',
          error: 'Kunde inte skapa pushnotis',
        },
        {
          duration: 8000,
        }
      ),
    // If connection is lost we don't want it to queue up mutations
    networkMode: 'always',
    onSuccess: () => {
      // Invalidate all notifications queries to update the UI
      queryClient.invalidateQueries(['notifications']);
    },
  });
};

// Mutation call
async function createNotification(data: PostPushNotification) {
  return fetchWithErrorThrowing('/notifications', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: new Headers({ 'content-type': 'application/json' }),
  });
}
